import React from 'react';
import { Award, Cake, Dumbbell, Flame } from 'lucide-react';

interface ProfileHighlightsProps {
  startDate?: string;
  beltCount: number;
  birthday?: string;
  monthlyTrainingCount?: number;
}

interface StatItem {
  icon: React.ElementType;
  value: number;
  label: string;
  iconColor?: string;
}

const ProfileHighlights: React.FC<ProfileHighlightsProps> = ({ startDate, beltCount, birthday, monthlyTrainingCount }) => {
  const hasStartDate = startDate && !isNaN(new Date(startDate).getTime());
  const yearsTraining = hasStartDate
    ? Math.floor((new Date().getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24 * 365))
    : null;

  const hasBirthday = birthday && !isNaN(new Date(birthday).getTime());
  const age = hasBirthday
    ? Math.floor((new Date().getTime() - new Date(birthday).getTime()) / (1000 * 60 * 60 * 24 * 365))
    : null;

  const items: StatItem[] = [
    ...(yearsTraining !== null ? [{ icon: Dumbbell, value: yearsTraining, label: 'anos treinando' }] : []),
    { icon: Award, value: beltCount, label: 'graduações' },
    ...(monthlyTrainingCount != null && monthlyTrainingCount > 0
      ? [{
          icon: Flame,
          value: monthlyTrainingCount,
          label: monthlyTrainingCount === 1 ? 'treino este mês' : 'treinos este mês',
          iconColor: 'text-orange-400',
        }]
      : []),
    ...(age !== null ? [{ icon: Cake, value: age, label: 'anos de idade' }] : []),
  ];

  return (
    <div className="flex shrink-0 flex-wrap justify-center gap-x-5 gap-y-2 md:flex-col md:justify-start md:gap-2.5">
      {items.map((item, i) => {
        const Icon = item.icon;
        return (
          <div key={i} className="flex items-center gap-2">
            <Icon className={`size-4 shrink-0 ${item.iconColor || 'text-yellow-400'}`} />
            <span className="text-xl font-bold leading-none text-foreground sm:text-lg">{item.value}</span>
            <span className="text-[13px] text-muted-foreground sm:text-xs">{item.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ProfileHighlights;
